<template>
  <div class="footer-sd" :class="{fixed: fixed}">
    <template v-if="isMobile">
      <template v-if="loginUser">
        <template v-if="parseInt(loginUser.is_self) !== 1">
          <p class="message">学术主页由学术格子自动生成</p>
          <template v-if="loginUser && parseInt(loginUser.homepage_uid) > 0">
            <img src="./image/mobile_self_old.jpg" alt="" @click="createMyHomepage">
          </template>
          <template v-else>
            <img src="./image/mobile_self_new.jpg" alt="" @click="createMyHomepage">
          </template>
        </template>
        <template v-else>
          <img src="./image/mobile_group_banner.png" @click="createOtherpage('http://group.acagrid.com/')"/>
        </template>
      </template>
      <template v-if="!loginUser && banner">
        <p class="message">学术主页由学术格子自动生成</p>
        <img src="./image/mobile_self_new.jpg" @click="createMyHomepage">
      </template>
    </template>
    <el-row type="flex" justify="center" v-else>
      <el-col :md="16" :xs="24">
        <template v-if="loginUser">
          <template v-if="parseInt(loginUser.is_self) !== 1">
            <template v-if="loginUser && parseInt(loginUser.homepage_uid) > 0">
              <img src="./image/pc_self_old.jpg" alt="" @click="createMyHomepage">
            </template>
            <template v-else>
              <img src="./image/pc_self_new.jpg" alt="" @click="createMyHomepage">
            </template>
          </template>
          <template v-else>
            <img src="./image/pc_group_banner.png" @click="createOtherpage('http://group.acagrid.com/')"/>
          </template>
        </template>
        <template v-else>
          <img src="./image/pc_self_new.jpg" @click="createMyHomepage">
        </template>
      </el-col>
    </el-row>
    <p class="copyright" :class="[fixed ? 'fixed' : '']">&#169; {{name}} | Powered by 学术格子</p>
  </div>
</template>
<script>
export default {
  props: {
    fixed: Boolean,
    isMobile: Boolean,
    name: String,
    loginUser: Object,
    banner: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      mobileDialogVisible: false
    }
  },
  methods: {
    createMyHomepage () {
      this.$emit('createMyHomepage')
    },
    createOtherpage (url) {
      window.open(url)
    }
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/FooterAd/index.vue